import { useState } from 'react'

export const ORIGINAL_LOGIN_USER_KEY = 'originalLoginUser'

const toId = (value) => {
  const num = Number(value)
  return Number.isFinite(num) ? num : value
}

export const originalUserSearchParams = (loginData) => {
  const storedUser = getOriginalLoginUser()
  const source = storedUser?.intUserID ? storedUser : loginData
  const params = new URLSearchParams()
  params.set('origUserID', source?.intUserID ?? '')
  params.set('origUserName', source?.strUserName ?? '')
  params.set('origCompanyID', source?.intCompanyID ?? '')
  params.set('origCompanyName', source?.strCompanyName ?? '')
  params.set('origBranchID', source?.intBranchID ?? '')
  params.set('origBranchName', source?.strBranchName ?? '')
  return params.toString()
}

export const persistOriginalLoginUser = (searchParams) => {
  const origUserID = searchParams.get('origUserID')
  if (!origUserID) return

  const originalLoginUser = {
    intUserID: toId(origUserID),
    strUserName: searchParams.get('origUserName') || '',
    intCompanyID: toId(searchParams.get('origCompanyID')),
    strCompanyName: searchParams.get('origCompanyName') || '',
    intBranchID: toId(searchParams.get('origBranchID')),
    strBranchName: searchParams.get('origBranchName') || '',
  }
  sessionStorage.setItem(ORIGINAL_LOGIN_USER_KEY, JSON.stringify(originalLoginUser))
}

export const getOriginalLoginUser = () => {
  const raw = sessionStorage.getItem(ORIGINAL_LOGIN_USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export default function useToken() {
  const getToken = () => {
    const tokenString = sessionStorage.getItem('token')
    const userToken = JSON.parse(tokenString)
    return userToken
  }

  const [token, setToken] = useState(getToken())

  const saveToken = (userToken) => {
    sessionStorage.setItem('token', JSON.stringify(userToken))
    setToken(userToken)
  }

  return {
    loginData: token,
    setLoginData: saveToken,
    originalLoginUser: getOriginalLoginUser(),
  }
}
